
		<ng-template component-host></ng-template>
	